// Components
import IconButton from '../../../atoms/IconButton/IconButton';
// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './SimpleBooleanCell.module.css';

/**
 * Simple boolean cell component for SimpleTable
 * @param {object} props - Component props
 * @param {boolean} props.value - The boolean value
 * @param {string} props.trueIcon
 * @param {string} props.falseIcon
 * @param {'left' | 'center' | 'right'} [props.align='center'] - Alignment
 * @param {string} [props.className=''] - Additional CSS classes
 * @returns {JSX.Element} SimpleBooleanCell component
 */
export default function SimpleBooleanCell({
  value = false,
  trueIcon = '',
  falseIcon = '',
  align = 'center',
  className = '',
}) {
  const iconName = value ? trueIcon : falseIcon;

  return (
    <div className={cn([
      styles['simple-boolean-cell'],
      className,
      align && styles[`simple-boolean-cell-align-${align}`],
    ])}
    >
      <IconButton
        icon={iconName}
        disabled
        className={styles['simple-boolean-button']}
        color="no-background"
      />
    </div>
  );
}
